import React, { useState, useEffect } from 'react'
import moment from "moment";
import { DatePicker, Table, Tag } from "antd";
import { CalendarOutlined, DownloadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import simplActions from '../../redux/simpl/actions'
import { CSVLink } from "react-csv"
const { getSimplData } = simplActions


const columns = [
    {
        title: '#',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: 'DATE',
        dataIndex: 'date',
    },

    {
        title: 'REGISTRATION TYPE',
        dataIndex: 'registration_type',
    },
    {
        title: 'BILL PERIOD',
        dataIndex: 'bill_period',
        // sorter: (a, b) => a.open_complaint.localeCompare(b.open_complaint)
    },
    {
        title: 'DEBIT TYPE',
        dataIndex: 'debitType',
    },
    {
        title: 'DEBIT DATE',
        dataIndex: 'debitDate',
    },
    {
        title: 'AMOUNT',
        dataIndex: 'amount',
    },
    {
        title: 'PAYMENT MODE',
        dataIndex: 'paymentMode',
    },


    {
        title: 'STATUS',
        dataIndex: 'status',

    },
];

function Simpl() {
    const dispatch = useDispatch()
    const [search, setSearch] = useState("");
    const [tableParams, setTableParams] = useState({
        current: 1,
        pageSize: 10,
    });
    const { simplResponseData, totalData, loading } = useSelector((state) => state.simplReducer)
    const now = moment();
    const formattedDate = now.format('YYYY-MM-DD');
    const formattedTime = now.format('HH-mm-ss');
    const newFilename = `simpl_data_${formattedDate}_${formattedTime}.csv`;

    useEffect(() => {
        dispatch(getSimplData())
    }, [])

    const data = simplResponseData.simplData &&
        simplResponseData.simplData.length > 0 &&
        simplResponseData.simplData.map((items, index) => {
            return {
                key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
                // ref_id: items.refId,
                registration_type: items.registrationType,
                paymentMode: <Tag color="cyan">
                    {items.paymentMode}
                </Tag>,
                bill_period: `${items.billPeriod}`,
                date: (<>
                    <p className="m-0 p-0">
                        {moment(items.createTime).format("DD MMMM YYYY")}
                    </p>
                    <p className="m-0 p-0">
                        {moment(items.createTime).format("hh:mm:ss A")}
                    </p>
                </>),
                debitType: items.debitType,
                amount: items.amount,
                debitDate: items.debitDate,
                status: <Tag color={items.responseReason === 'Success' ? "green" : items.responseReason === 'Pending' ? "yellow" : "red"} className="draft">{items.responseReason}</Tag>

            };
        });

    const handleSearch = (e) => {
        e.preventDefault()
        const value = e.target.value;
        setSearch(value);

        if (value.length > 1) {
            dispatch(getSimplData(0, 10, value));
        }
        if (value.length < 1) {
            dispatch(getSimplData(0, 10));
        }
    };


    const handlePageChange = async (pagination) => {
        const { current, pageSize } = pagination;
        setTableParams({ current, pageSize });
        dispatch(getSimplData(current, pageSize));

    };

    const handleFilterChange = () => {
        setSearch("");
        dispatch(getSimplData());
    }

    const exportData = simplResponseData.simplData &&
        simplResponseData.simplData.length > 0 &&
        simplResponseData.simplData.map((items, index) => {
            return {
                REF_ID: items.refId,
                REGISTRATION_TYPE: items.registrationType,
                PAYMENT_MODE: items.paymentMode,
                BILL_PERIOD: items.billPeriod,
                DEBIT_TYPE: items.debitType,
                DEBIT_DATE: items.debitDate,
                AMOUNT: items.amount,
                createdDate: items.createTime,
                status: items.responseReason,
            }
        });
    return (
        <div className="mainContain">
            <h1 className="transaction">SIMPL</h1>

            <div className="datesearchFi">
                <div className="">
                    <select className="transactioSelct" onChange={handleFilterChange}>
                        <option>Registration Type</option>
                        <option>Debit Type</option>

                    </select>
                    <input
                        style={{ width: "350px" }}
                        type="text"
                        placeholder="Search  by Registration Type,Debit Type"
                        className="inputSearch"
                        value={search}
                        onChange={handleSearch}
                    />
                </div>
                {/* <div className="inputfatef bg-white">
                    <div style={{ borderRight: "1px solid rgba(141, 141, 141, 1)" }}>
                        <span>From (DD-MM-YYYY)</span>
                        <DatePicker
                            value={fromDate}
                            style={{ width: '100%', border: 'none' }}
                            onChange={handleFromDateChange}
                            disabledDate={disabledDate}
                            format="DD-MM-YYYY"

                            suffixIcon={<CalendarOutlined style={{ color: 'rgba(22, 22, 22, 0.25)' }} />}
                        />

                    </div>
                    <div>
                        <span>To (DD-MM-YYYY)</span>
                        <DatePicker
                            value={toDate}
                            style={{ width: '100%', border: 'none' }}
                            onChange={handleToDateChange}
                            disabledDate={disabledToDate}
                            format="DD-MM-YYYY"
                            suffixIcon={<CalendarOutlined style={{ color: 'rgba(22, 22, 22, 0.25)' }} />}
                        />
                    </div>
                </div> */}
                <div className='exportBtnDiv'>
                    <CSVLink
                        filename={newFilename}
                        data={exportData ? exportData : []}
                        className="btn exportBtn"
                    >
                        <DownloadOutlined />
                        Export
                    </CSVLink>
                </div>

            </div>


            <div className="mt-3">
                <Table
                    columns={columns}
                    dataSource={data}
                    // loading={loading}
                    pagination={{
                        total: totalData,
                        current: tableParams.current,
                        pageSize: tableParams.pageSize,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ['10', '20', '50'],
                    }}
                    onChange={handlePageChange}
                />

            </div>

        </div>
    )
}

export default Simpl
